module.exports = __webpack_public_path__ + "static/media/comment3_1.b50335b2.png";